import { ADD_PRODUCT, DELETE_PRODUCT, ADD_TO_CART, REMOVE_FROM_CART, DECREMENT_PRODUCT_COUNT, INCREMENT_PRODUCT_COUNT } from "./actionTypes";
import data from "./data.json";

const initialState = data; //Initial Dataset
// const initialState = [];


const nextProductID = (products) => {
    const maxID = products.reduce((maxID, product) => Math.max(product.id, maxID), -1);
    return maxID + 1;
};

export const cartReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_PRODUCT:
            return [
                ...state,
                {
                    id: nextProductID(state),
                    ...action.payload,
                    totalOrder: 0,
                },
            ];

        case DELETE_PRODUCT:
            return state.map((product) => {
                if (product.id !== action.payload) {
                    return product;
                }
                return {
                    ...product,
                    totalOrder: product.totalOrder - 1,
                    count: product.count + 1,
                };
            });

        case ADD_TO_CART:
            return state.map((product) => {
                if (product.id !== action.payload) {
                    return product;
                }
                return {
                    ...product,
                    totalOrder: product.totalOrder + 1,
                    count: product.count - 1,
                };
            });

        case REMOVE_FROM_CART:
            return state.map((product) => {
                if (product.id !== action.payload) {
                    return product;
                }
                return {
                    ...product,
                    totalOrder: 0,
                    count: product.count + product.totalOrder,
                };
            });

        case INCREMENT_PRODUCT_COUNT:
            return state.map((product) => {
                if (product.id !== action.payload) {
                    return product;
                }
                return {
                    ...product,
                    totalOrder: product.totalOrder + 1,
                    count: product.count - 1,
                };
            });

        case DECREMENT_PRODUCT_COUNT:
            return state.map((product) => {
                if (product.id !== action.payload) {
                    return product;
                }
                return {
                    ...product,
                    totalOrder: product.totalOrder - 1,
                    count: product.count + 1,
                };
            });

        default:
            return state;
    }
};
